import { z } from "zod";
const WowpressLoginRequest = z.object({
  authUid: z.string(),
  authPw: z.string()
});
export {
  WowpressLoginRequest
};
//# sourceMappingURL=login.js.map